import { ovl } from "../../../../_ovlclient/src"
import { Data } from "../../../../_ovlclient/src/dataapi"
import { DialogModal } from "../../../../_ovlclient/src/library/dialog/dialogapi"
import { SYSFormField } from "../../../../_ovlclient/src/library/forms/fieldapi"
import { FormInit } from "../../../../_ovlclient/src/library/forms/formapi"
import { SYSColumnDef } from "../../../src/library/table/tableapi"
import { InitStateFromLogin } from "./helpers"

export const LoginStart = async () => {
  let fields: { [key: string]: SYSFormField } = {
    user: {
      value: "",
      ui: {
        labelTranslationKey: "SYSLoginUser",
        autocomplete: "username",
      },
    },
    pw: {
      value: "",
      ui: {
        labelTranslationKey: "SYSLoginPassword",
        autocomplete: "current-password",
        isPassword: true,
      },
    },
  }

  await FormInit("SYSLogin", fields)

  // Gracefully exit if authentication is not configured/registered in appdef.ts
  // and returning after FormInit is a must because we need the FormState for auth endpoints so LoginForm pops up
  if (ovl.getState().ovl.app.ignoreLoginOnStartup) {
    return
  }

  //if (SYSConfig?.fetch?.authMode === "cookie") {
  let res
  do {
    res = await Data(
      "users/authenticate2",
      { tz: Intl.DateTimeFormat().resolvedOptions().timeZone },
      { isAuthCheck: true }
    )
    // 401 will be handled by relogin loop
    // if 200 everything fine...
    if (res && res.status === 200) {
      await InitStateFromLogin(res)
    }
  } while (res?.TOTPCanceled)
}
